module.exports = __webpack_public_path__ + "static/media/main idea.f4947fe5.mp3";